__webpack_require__.p = "/kendo-react-ui-develop/components/";